import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

import SectionHeader from "@/components/SectionHeader";

const testimonials = [
  {
    name: "Thomas M.",
    role: "Bauunternehmer",
    text: "Für kleinere Einsätze ist das genau die richtige Lösung. Keine langen Abstimmungen, kein Warten, saubere Qualität.",
    stars: 5,
  },
  {
    name: "Sandra K.",
    role: "Privatkundenprojekt",
    text: "Übersichtlich, unkompliziert und vor allem schnell. Für mein Vorhaben war die flexible Menge entscheidend.",
    stars: 5,
  },
  {
    name: "Michael R.",
    role: "Garten- und Landschaftsbau",
    text: "Wenn spontan Material fehlt, spart uns die Station echte Baustellenzeit. Genau das macht den Unterschied.",
    stars: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <section className="section-shell overflow-hidden">
      <div className="absolute left-[8%] top-20 hidden font-display text-[14rem] leading-none text-primary/[0.04] xl:block">
        ”
      </div>

      <div className="container mx-auto px-4">
        <SectionHeader
          eyebrow="Kundenstimmen"
          title={
            <>
              Vertrauen entsteht
              <br />
              durch Verlässlichkeit.
            </>
          }
          description="Die Rückmeldungen sind nicht laut, sondern eindeutig: die Station funktioniert schnell, planbar und ohne unnötige Reibung."
          centered
        />

        <div className="grid gap-8 border-t border-white/10 pt-8 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <motion.article
              key={testimonial.name}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ delay: index * 0.12, duration: 0.55 }}
              className="group border-b border-white/10 pb-8 md:border-b-0 md:border-r md:pb-0 md:pr-8 last:border-r-0"
            >
              <div className="mb-5 flex items-center justify-between">
                <div className="flex gap-1">
                  {Array.from({ length: testimonial.stars }).map((_, starIndex) => (
                    <Star key={starIndex} className="h-4 w-4 fill-primary text-primary" />
                  ))}
                </div>
                <Quote className="h-8 w-8 text-primary/18 transition-colors duration-300 group-hover:text-primary/35" />
              </div>

              <p className="text-base leading-relaxed text-foreground md:text-[1.04rem]">
                “{testimonial.text}”
              </p>

              <div className="mt-8 border-t border-white/10 pt-5">
                <p className="font-display text-xl uppercase tracking-[0.04em] text-foreground">
                  {testimonial.name}
                </p>
                <p className="mt-1 text-sm text-muted-foreground">{testimonial.role}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
